module.exports = __webpack_public_path__ + "img/safety-tool-fmea-item3-1.f066d3a6.png";